import { functions } from '../../firebase';
import { httpsCallable } from 'firebase/functions';

/**
 * Updates a user's role in Firebase Auth custom claims
 * @param {string} userId - The ID of the user to update
 * @param {string} newRole - The new role to assign
 * @param {string} venueId - The ID of the venue for which to update the role
 * @returns {Promise<void>}
 */
export const updateUserRole = async (employeeInfo, newRole, venueId) => {
    try {
        const updateRole = httpsCallable(functions, 'updateUserRole');

        // We collect all the new userIds and the old uid for backwards compatibility!
        const uids = [...new Set([].concat(employeeInfo.uids || []).concat(employeeInfo.uid || []))];

        // We use allSettled to ignore missing uids (it may happen!)
        await Promise.allSettled(uids.map((userId) => updateRole({ userId, role: newRole, venueId })));
    } catch (error) {
        console.error('Error updating user role:', error);
        throw error;
    }
};
